var observer = new IntersectionObserver(function(entries) {
	// no intersection with screen
	if(entries[0].intersectionRatio === 0)
		document.querySelector("#nav-container").classList.add("nav-container-sticky");
	// fully intersects with screen
	else if(entries[0].intersectionRatio === 1)
		document.querySelector("#nav-container").classList.remove("nav-container-sticky");
}, { threshold: [0,1] });

observer.observe(document.querySelector("#nav-container-top"));


/* RESERVIT */
const arrivee = document.getElementById('dateArrivee');
const depart = document.getElementById('dateDepart');

// 👉 Empêche départ < arrivée
arrivee.addEventListener('change', () => {
  depart.min = arrivee.value;

  if (depart.value && depart.value <= arrivee.value) {
    const nextDay = new Date(arrivee.value);
    nextDay.setDate(nextDay.getDate() + 1);
    depart.value = nextDay.toISOString().split('T')[0];
  }
});

// 👉 Empêche arrivée > départ
depart.addEventListener('change', () => {
  arrivee.max = depart.value;
});

// 👉 Submit
document.getElementById('bookingForm').addEventListener('change', async (e) => {
    e.preventDefault();
    searchprice();
});
document.getElementById('bookingForm').addEventListener('submit', async (e) => {
    e.preventDefault();
    //formatage des dates au format attendu par le moteur de réservation
    //             https://premium.logishotels.com/fo/booking/233/10560/availability?nbroom=1&specialMode=default&begindate=09%2F04%2F2026&roomAge1=40,40&langcode=FR&enddate=18%2F04%2F2026
    // dates au format jj%2fmm%2faaaa
    const dateArrivee = new Date(arrivee.value);
    const dateDepart = new Date(depart.value);
    const formattedDateArrivee = `${String(dateArrivee.getDate()).padStart(2, '0')}%2F${String(dateArrivee.getMonth() + 1).padStart(2, '0')}%2F${dateArrivee.getFullYear()}`;
    const formattedDateDepart = `${String(dateDepart.getDate()).padStart(2, '0')}%2F${String(dateDepart.getMonth() + 1).padStart(2, '0')}%2F${dateDepart.getFullYear()}`;

    // format le roomAge1 en fonction du nombre d'adultes et d'enfants
    const nbAdultes = parseInt(document.getElementById('nbAdultes').value);
    const nbEnfants = parseInt(document.getElementById('nbEnfants').value);
    const roomAge1 = `${'40,'.repeat(nbAdultes)}${'10,'.repeat(nbEnfants)}`.slice(0, -1);
    // document.querySelector('input[name="roomAge1"]').value = roomAge1;
    const actionUrl = e.target.action;
    const queryString = `nbroom=1&specialMode=default&roomAge1=${roomAge1}&langcode=FR&begindate=${formattedDateArrivee}&enddate=${formattedDateDepart}`;

    window.open(`${actionUrl}?${queryString}`, '_blank');
});

function loading() {
    $('.prixofficiel').text('...');
    $('.prixbooking').text('...');
    $('.prixeconomie').text('...');
}
async function searchprice() {
    loading();
    const dateA = new Date(arrivee.value);
    const dateD = new Date(depart.value);

    const nights = Math.round((dateD - dateA) / (1000 * 60 * 60 * 24));

    const data = {
        dateArrivee: arrivee.value,
        dateDepart: depart.value,
        nights: nights,
        adults: parseInt(document.getElementById('nbAdultes').value),
        children: parseInt(document.getElementById('nbEnfants').value)
    };

    const response = await fetch('/reservit/search', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify(data)
    });
    
    const result = await response.json();

    afficherResultats(result);
}

function afficherResultats(data) {
  const prixReservit = data?.bestPrice_unFormatted ?? 'N/A';
  const prixBooking = data?.bestPriceDistrib_unFormatted ?? 'N/A';
  const economie = (prixReservit !== 'N/A' && prixBooking !== 'N/A') ? Number.parseFloat(prixBooking - prixReservit).toFixed(2) : 'N/A';

  if(prixReservit==-1) {
    $('.prix_dispo').hide();
    $('.prix_non_dispo').show();
    $('.prixofficiel').text('Indisponible');
    $('.prixbooking').text('');
    $('.prixeconomie').text('');
  } else {
    $('.prix_dispo').show();
    $('.prix_non_dispo').hide();
    $('.prixofficiel').text(prixReservit !== 'N/A' ? `${prixReservit} €` : 'N/A');
    $('.prixbooking').text(prixBooking !== 'N/A' ? `${prixBooking} €` : 'N/A');
    $('.prixeconomie').text(economie !== 'N/A' ? `${economie} €` : 'N/A');
  }
}

setTimeout(function() {
    // searchprice();
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        jQuery('#rsvit_btn_mobile').show('swing');
    } else {
        jQuery('#ReservitBestPriceWidget').show('swing');
        setTimeout(function() {
            jQuery("#rsvit_btn_mobile").trigger("click");
        }, 1000);
    }
}, 2000);

jQuery(function() {
    searchprice();
    jQuery('#box_btn').click(function() {
        //jQuery('#rsvit_btn').show('swing');
        jQuery('#ReservitBestPriceWidget').hide('swing');
    });
    jQuery('#rsvit_btn').click(function() {
        //jQuery('#rsvit_btn').hide('swing');
        jQuery('#ReservitBestPriceWidget').show('swing');
    });jQuery('#rsvit_btn_mobile').click(function() {
        //jQuery('#rsvit_btn').hide('swing');
        jQuery('#ReservitBestPriceWidget').show('swing');
    });
});
/* FIN RESERVIT */



/* --------- Ancres animées --------- */

$(document).on('click', 'a[href^="#"]:not([data-toggle="collapse"], [data-toggle="tab"])', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 800);
});

$(document).ready(function(){

    /* --------- Sous-Menu / open Bootstrap 4 dropdown on hover --------- */
    $('.primaryMenu .dropdown-toggle').click(function(e) {
      if ($(document).width() > 768) {
        e.preventDefault();

        var url = $(this).attr('href');

        if (url !== '#') {
          window.location.href = url;
        }
      }
    });

	/* --------- retour en haut de page --------- */
	$(window).scroll(function() {
	  if($(window).scrollTop() == 0){
	    $('#scrollToTop').fadeOut("fast");
	  } else {
	    $('#scrollToTop').fadeIn("fast");
	  }
	});

	$('#scrollToTop').on('click', function(event){    // remplacer .live par .on depuis jquery 1.10
	  event.preventDefault();
	  $('html,body').animate({scrollTop: 0}, 'slow');
	});

	/* --------- target _blank --------- */
	$("a.lien_ext").click(function(){
		this.target = "_blank";
	});

	/* --------- Mentions legales ---------
	$('#mentions').click(function() { $('#mentions-bloc').fadeIn("fast"); });
	$('#close_mentions').click(function() { $('#mentions-bloc').fadeOut("fast"); });
  */

  /* --------- jQuery CookieBar --------- */
  // $.cookieBar({
  //   message: 'Ce site utilise des cookies. En naviguant sur notre site vous acceptez l\'installation et l\'utilisation des cookies sur votre ordinateur. <a href="/politique-de-confidentialite" class="btn-warning">En savoir plus</a>',
  //   acceptText: 'OK',
  //   fixed: true,
  //   bottom: true
  // });

	/* --------- Affiche la galerie quand le chargement est fini ---------
	$("#contenuGalerie").fadeIn("slow");
	$("#loadingContent").hide();
    */

  /* --------- Toogle WebRappel--------- */
	$('#toggleRappel').click(function() { $('.widget_rappel').slideDown(); });
	$('#closeRappel').click(function() { $('.widget_rappel').slideUp(); })

  /* --------- Demo Assets --------- */
  $(window).scroll(function () {
      var top = $(document).scrollTop();
      $('.splash').css({
        'background-position': '0px -'+(top/3).toFixed(2)+'px'
      });
      if(top > 50)
        $('#home > .navbar').removeClass('navbar-transparent');
      else
        $('#home > .navbar').addClass('navbar-transparent');
  });

  $("a[href='#']").click(function(e) {
    e.preventDefault();
  });

  var $button = $("<div id='source-button' class='btn btn-primary btn-xs'>&lt; &gt;</div>").click(function(){
    var html = $(this).parent().html();
    html = cleanSource(html);
    $("#source-modal pre").text(html);
    $("#source-modal").modal();
  });

  $('.bs-component [data-toggle="popover"]').popover();
  $('.bs-component [data-toggle="tooltip"]').tooltip();

  $(".bs-component").hover(function(){
    $(this).append($button);
    $button.show();
  }, function(){
    $button.hide();
  });

  function cleanSource(html) {
    html = html.replace(/×/g, "&close;")
               .replace(/«/g, "&laquo;")
               .replace(/»/g, "&raquo;")
               .replace(/←/g, "&larr;")
               .replace(/→/g, "&rarr;");

    var lines = html.split(/\n/);

    lines.shift();
    lines.splice(-1, 1);

    var indentSize = lines[0].length - lines[0].trim().length,
        re = new RegExp(" {" + indentSize + "}");

    lines = lines.map(function(line){
      if (line.match(re)) {
        line = line.substring(indentSize);
      }

      return line;
    });

    lines = lines.join("\n");

    return lines;
   }
});
